<template>
  <div class="user_body" v-loading="loading">
    <div class="mbx">
      <img src="@/assets/icon_home_dd.png">
      <span>首页>商城>产品详情</span>
    </div>
    <div class="div_content">
      <Category/>
      <div class="div_right" v-if="goodsDetail">
        <div class="product_info" >
          <!-- <img :src="goodsDetail.images[currImg]"> -->
          <el-image class="image" :src="(goodsDetail.images&&goodsDetail.images[currImg])||goodsDetail.thumb" :preview-src-list="goodsDetail.images||[goodsDetail.thumb]" fit="scale-down"></el-image>
          <div class="xb">
            <div class="xb1" >
              <span class="xb1_title">{{goodsDetail.title || goodsDetail.name}}</span>
              <span class="xb1_id">货号：{{huohao}}</span>
              <!-- <span class="xb1_spec" v-if="goodsDetail.is_spec==1">规格：{{currentSku.sku_name || '--'}}</span> -->
              <!-- <span class="xb1_price" v-if="currentSku&&currentSku.price">价格：￥{{currentSku.price}}</span> -->
              <span class="xb1_price" >价格：￥{{price}}</span>
            </div>
           
            <div class="sku-list" v-if="goodsDetail.is_spec==1">
              <div class="spec-it" v-for="(item,index) in spec_list" :key="index">
                <div class="sku_label">{{item.name}}：</div>
                <div class="sku-item" v-for="(spec,idx) in item.list" :key="idx" :class="{on:idx==specs[index]}" @click="onSpec(index,idx)">
                    {{spec.name}}
                  </div>
              </div>
              <!-- <template >
                <div class="sku_label">选择规格：</div>
                
                <div class="sku-item" :class="{active:currentSku&&currentSku.sku==item.sku}" v-for="item in skuData" :key="item.id" @click="selectSku(item)">
            
                  <span>{{decodeHtmlEntities(item.sku_name)}}</span>
                </div>
              </template> -->
            </div>
            <div class="prices_list">
              <div class="nums">
                <span class="text">数量：</span>
                <el-input-number v-model="number"  @change="onNumberChange" :min="1" :max="stock" label="描述文字"></el-input-number>
              </div>
              <div class="cas_prrs">
                <span @click="addCart" class="addCart">加入购物车</span>
                <span @click="buyProduct" class="buyProduct">立即购买</span>
              </div>
            </div>
          </div>
        </div>
        <div class="imgs_list" v-if="goodsDetail.images">
          <img
            :src="item"
            :class="currImg==index?'imgs_list_img_s':'imgs_list_img_n'"
            v-for="(item,index) in goodsDetail.images"
            :key="index"
            @click="currImg=index"
          >
        </div>
        <div class="nav_list">
          <div
            class="nav_item_out"
            v-for="(item,index) in navList"
            :key="index"
            @click="tabIdexClick(index)"
          >
            <span :class="tabIdex==index?'color_orage':'color_dark_green'">{{item}}</span>
            <div :class="tabIdex==index?'line':'line_white'"></div>
          </div>
        </div>

        <template v-if="tabIdex==0" >
          <div class="cc_content" v-html="goodsDetail.content">
            
          </div>
          <el-empty v-if="!goodsDetail.content" description="暂无内容"></el-empty>
        </template>

        <div class="cp" v-if="tabIdex==1">
          <div class="doc-list">
            <div class="item-wrap">
              <div class="item-title">说明：</div>
              <div class="doc-item" v-if="goodsDetail.describe_file">
                <a :href="goodsDetail.describe_file" class="doc" target="_blank">{{ goodsDetail.describe_filename }}</a>
                <a :href="goodsDetail.describe_file" class="more" :download="goodsDetail.describe_filename">下载></a>
              </div>
              <!-- <el-empty v-if="!goodsDetail.describe_file" description="暂无说明"></el-empty> -->
            </div>
            <div class="item-wrap">
              <div class="item-title">报告：</div>
              <div class="doc-item" v-for="(item,index) in goodsDetail.bg_filenames" :key="item.id">
                <a a :href="goodsDetail.bg_file[index]" class="doc" target="_blank">{{ item }}</a>
                <a :href="goodsDetail.bg_file[index]" class="more" :download="goodsDetail.bg_filenames[index] || 'report'">下载></a>
              </div>
              <!-- <el-empty v-if="goodsDetail.bg_filenames.length==0" description="暂无报告"></el-empty>  -->
            </div>
            <div class="item-wrap" v-if="goodsDetail.videos&&goodsDetail.videos.length>0">
              <div class="item-title">视频：</div>
              <div class="doc-item" v-for="(item,index) in goodsDetail.videos" :key="item.id">
                <video class="video-item" :src="item" controls></video>
              </div>
            </div>
          </div>
          <!-- <el-empty v-if="goodsDetail.bg_filenames.length==0&&!goodsDetail.describe_file" description="暂无产品资料"></el-empty> -->
        </div>

        <div class="carousel-track" v-if="tabIdex==2">
          <!-- 循环渲染双倍图片实现无缝衔接 -->
          <div v-for="(item, index) in relatedGoods" :key="index" class="carousel-item3" @click="$router.push(`/buyproduct/${item.id}?number=1`)">
            <img :src="item.thumb"  class="carousel-item2_img2">
            <span class="carousel-item2_title">{{item.title}}</span>
          </div>
          <!-- <el-empty v-if="relatedGoods.length==0" description="暂无相关产品"></el-empty> -->
        </div>

      </div>
    </div>
  </div>
</template><script>
import { mapGetters,mapActions } from 'vuex'
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  },
  data() {
    return {
      tabIdex: 0,
      id:null,
      sku_id:null,
      navList: ["产品概述", "产品资料", "相关产品"],
      currImg: 0,
      goodsDetail:null,
      spec:[],
      specs:[],
      skuData:[],
      currentSku:{},
      number:1,
      loading:false,
      catNo:'',
      lotNo:'',
      relatedGoods:[],
      spec_list:[],
      stock:0,
      thumb:'',
      huohao:'',
      price:0,
      score:0,
      total:0,
      sku:'',
      sku_name:'',
      sku_data:{},

    };
  },

  computed: {
    ...mapGetters(['base']),
  },
  watch:{
    '$route.params.id':{
      handler(newVal){
        this.id = newVal
        this.specs = []
        this.sku = ''
        this.sku_name = ''
        this.price = 0
        this.stock = 0
        this.thumb = ''
        this.huohao = ''
        this.number = 1
        this.getDetail()
        this.getSpec()
      },
      immediate:true
    },
    '$route.query.sku_id':{
      handler(newVal){
        this.sku_id = newVal
        this.getSpec()
        
      },
      immediate:true
    }
  },
  beforeMount(){
    // this.id = this.$route.params.id
    // this.getSpec()
    // if(this.$route.query.number){
    //   this.number = this.$route.query.number
    // }
  },
   
  mounted() {},

  methods: {
    ...mapActions(['getUser']),
    decodeHtmlEntities(text) {
      if (!text || typeof text !== 'string') return text || '--';
      
      const txt = document.createElement('textarea');
      txt.innerHTML = text;
      let decoded = txt.value;
      let prevDecoded = text;
      let decodeCount = 0;
      while (decoded !== prevDecoded && decodeCount < 3) {
        prevDecoded = decoded;
        txt.innerHTML = decoded;
        decoded = txt.value;
        decodeCount++;
      }
      
      return decoded;
    },
    onNumberChange(value){
      console.log('change',value)
      let num = value
      if(this.stock == 0){
        return this.$message.error("库存不足");
      }
      if(this.goodsDetail.is_spec == 1 && this.specs.length == 0){
        return this.$message.error("请选择规格");
      }
      if(this.stock <= 0){
        num = 1
        console.log('num1',num);
        this.number = num
        this.$forceUpdate()
        return this.$message.error("最低购买数量为1");
      }
      if(value > this.stock){
        num = this.stock
        this.number = num
        console.log('num2',num,this.number);
        this.$nextTick(()=>{
          this.$forceUpdate()
        })
        return this.$message.error("库存不足");
      }
    
    },
    onSpec(index,idx){
				if(this.specs.length == 0){
					for(let i = 0;i < this.spec_list.length;i++){
						if(i == index){
							this.specs.push(idx);
						}
						else{
							this.specs.push(0)
						}
					}
				}
				else{
					this.specs[index] = idx;
				}
        console.log('specs',this.specs);
				let sku_name = [];
				let sku = [];
				for(let i = 0;i < this.spec_list.length;i++){
					sku_name.push(this.spec_list[i].list[this.specs[i]].name);
					sku.push(this.spec_list[i].list[this.specs[i]].id);
				}
				sku = sku.join(",");
				this.sku = sku;
				this.sku_name = sku_name.join(",");
        console.log('sku',sku,this.sku_data,this.sku_data[sku]);
				this.price = parseFloat(this.sku_data[sku].price);
			
				this.stock = this.sku_data[sku].stock;
				this.thumb = this.sku_data[sku].thumb;
				this.huohao = this.sku_data[sku].huohao;
				if(this.total >= this.stock){
					this.total = this.stock;
				}
				if(this.price <= 0 && (this.type == 1||this.type==4)){
					this.toast("请重新选择规格");
				}
				if(this.price <= 0 && this.type == 2){
					this.toast("请重新选择规格");
				}
				if(this.stock <= 0){
					this.toast("库存不足");
				}
        this.$forceUpdate()
			},
    async getDetail(){
      this.loading = true
      try{
        const res = await this.$api.getGoodsDetail({id:this.id})
        if(res.code==1){
          this.goodsDetail = res.data.goods
          if(this.$route.query.number){
            this.number = this.$route.query.number
          }
          if(this.goodsDetail.xiangguan_goods&&this.goodsDetail.xiangguan_goods.length>0) this.relatedGoods =  this.goodsDetail.xiangguan_goods
          // if(this.goodsDetail.category_ids.length>0){
          //   this.associationCategoryGoods = []
          //   this.getAssociationCategoryGoods(this.goodsDetail.category_ids[0])
          // }
        }else{
          this.$message.error(res.msg||res.message||"获取详情失败")
        }
      }catch(err){
        console.log("err is",err)
        this.$message.error(err.message||err.msg)
      }finally{
        this.loading = false
      }
    },
    async getAssociationCategoryGoods(id) {
 
      try {
        const res = await this.$api.getAssociationCategoryGoods({ category_id: id })
        if (res.code == 1) {
          res.data.list.forEach(item => {
            this.associationCategoryGoods.push(...item.goods)
          })
          //根据id 去重 保留查询到的第一个
          this.associationCategoryGoods = this.associationCategoryGoods.filter((item,index,self)=>{
            return index === self.findIndex(t=>t.id===item.id)
          })

        } else {
          // this.associationCategoryGoods = []
        }
      } catch (err) {
        console.log(err)
        this.$message.error(err.message)
      }
    },
    async getSpec(){
      if(!this.id){
        
        return
      }
      try{
        const res = await this.$api.getGoodsSpec({id:this.id,type:this.selectedCategory})
        if(res.code==1){
          // this.goodsDetail = res.data.goods
          this.spec_list = res.data.spec_list
          this.skuData = res.data.sku_data
          this.sku_data = res.data.sku_data
          this.price = res.data.price;
          this.huohao = res.data.goods.huohao;
          this.stock = res.data.stock;
          // Object.values(this.skuData).forEach((value,index)=>{
           
          //   if(value.id==this.$route.query.sku_id){
          //     this.currentSku = value
          //     this.sku = Object.keys(this.skuData)[index]
          //   }else if(index == 0){
          //     this.sku = Object.keys(this.skuData)[0]
          //     this.currentSku = value
          //   }

          // })
          if(this.sku_id != 0){
							
							let sku_name = [];
							let sku1 = "";
							let sku = [];
							let specs = [];
							
							for(let i in this.sku_data){
								
								if(this.sku_data[i].id == this.sku_id){
									sku1 = sku = this.sku_data[i].sku;
									break;
								}
							}
							
							if(sku1){
								sku1 = sku1.split(",");
								
								for(let i = 0;i < this.spec_list.length;i++){
									for(let j = 0;j < this.spec_list[i].list.length;j++){
										
										if(sku1[i] == this.spec_list[i].list[j].id){
											specs.push(j);
											sku_name.push(this.spec_list[i].list[j].name);
										}
									}
								}
								if(specs.length == this.spec_list.length){
									this.sku = sku;
									this.sku_name = sku_name.join(",");
									this.specs = specs;
								}
								
							}
							
						}
            console.log('specs',this.specs);
        }else{
          this.$message.error(res.msg||res.message||"获取规格失败")
        }
      }catch(err){
        console.log("err is",err)
        this.$message.error(err.message||err.msg)
      }
    },
    buyProduct() {
      if(this.goodsDetail.is_spec == 1 && !this.sku_data[this.sku]){
					return this.$message.error("请选择规格");
				}
        let sku_id = '';
      if(this.goodsDetail.is_spec == 1){
					sku_id = this.sku_data[this.sku].id;
				}
      if(this.currentSku.stock <= 0 || this.currentSku.stock < this.number){
					return this.$message.error("库存不足");
				}
      this.$api.getOrderCheck({goods_id:this.goodsDetail.id}).then(res => {
						if(res.code == 1){
							
              this.$router.push({path: `/confimorder?goods_id=${this.goodsDetail.id}&total=${this.number}&sku_id=${sku_id}`});
						}
						else{
							this.$message.error(res.message);
						}
					}).catch(err => {
						console.log(err);
					});
    
    },
    addCart(){
      if(this.currentSku.stock <= 0 || this.currentSku.stock < this.number){
					return this.$message.error("库存不足");
				}
      let sku_id = '';
      if(this.goodsDetail.is_spec == 1){
        if(!this.sku){
          return this.$message.error('请选择规格')
        }
        sku_id = this.sku_data[this.sku].id;
      }

      this.$api.addCart({goods_id:this.goodsDetail.id,sku_id:sku_id,total:this.number}).then(res => {
        if(res.code == 1){  
          this.$message.success("加入购物车成功");
          this.getUser()
        }else{
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    downloadManual(){
      window.open(this.goodsDetail.describe_file, '_blank');
    },
    downloadCOA(){
      window.open(this.goodsDetail.bg_file, '_blank');
    },

    tabIdexClick(index) {
      this.tabIdex = index;
    },

    selectSku(item){
      this.currentSku = item
    },
  }
};
</script>
<style lang="less"scoped>
.user_body {
  box-sizing: border-box;
  margin-top: 5.6875rem;
  background: #ffffff;
  padding-left: 15%;
  padding-right: 15%;
}

.mbx {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1.25rem 0;
  background: #ffffff;
}

.mbx img {
  width: .9081rem;
  height: .8413rem;
}

.mbx span {
  color: rgba(136, 136, 136, 1);
  font-size: .75rem;
}

.div_content {
  display: flex;
  flex-direction: row;
  position: relative;
}



.div_right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 12.5rem;
}

.product_info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.product_info .image {
  flex: 1;
  width: 25.875rem;
  height: 17.25rem;
  // padding: 0rem .875rem 1.4375rem .875rem;
  object-fit: cover;
  aspect-ratio: 3/2;
}

.xb {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;
  margin-left: 1.25rem;
}

.xb1 {
  display: flex;
  flex-direction: column;
}

.xb1_title {
  color: rgba(51, 51, 51, 1);
  font-size: 1.25rem;
  line-height: 2.625rem;
  font-weight: 700;
  margin-right: .625rem;
}

.xb1_id,.xb1_spec,.xb1_price {
  color: #666666;
  font-size: 1.25rem;
  line-height: 1.8125rem;
  margin-top: .625rem;
  margin-right: 1.25rem;
}
.sku_label {
  color: #666666;
  font-size: 1.25rem;
  line-height: 1.8125rem;
}
.car_icon {
  width: 1.75rem;
  height: 1.75rem;
}
.sku-list{
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  gap: .625rem;
  margin-top: .625rem;
}
.spec-it{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: .625rem;
  flex-wrap: wrap;
}
.sku-item{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: .625rem;
  cursor: pointer;
  border: .0625rem solid #eaeaea;
  padding: .3125rem .625rem;
  
  &:hover{
    border: .0625rem solid #3c9c8f;
  }
  &.on{
    border: .0625rem solid #3c9c8f;
    color: #3c9c8f;
  }
}
.prices_list {
  margin-top: .75rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.4375rem;
}

.nums {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: .625rem;
}

.nums .text {
  color: #666666 !important;
  font-size: 1rem !important;
  font-weight: 100 !important;
}

.cas_prrs {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.cas_prrs .addCart {
  cursor: pointer;
  background: #3c9c8f;
  font-size: 1rem;
  color: white;
  font-weight: 100;
  width: 8.5rem;
  text-align: center;
  line-height: 3.125rem;
  height: 3.125rem;
  padding: 0 !important;
  margin: 0 !important;
  margin-right: 2.5rem !important;
}

.cas_prrs .buyProduct {
  cursor: pointer;
  background: #e69f3e;
  font-size: 1rem;
  color: white;
  font-weight: 100;
  width: 8.5rem;
  text-align: center;
  line-height: 3.125rem;
  height: 3.125rem;
  padding: 0rem !important;
  margin: 0 !important;
}

.imgs_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: .625rem;
  // margin-left: .8125rem;
  
}
.imgs_list_img_n {
  cursor: pointer;
  width: 7rem;
  height:4.6875rem;
  aspect-ratio: 3/2;
}

.imgs_list_img_s {
  cursor: pointer;
  width: 6.875rem;
  height: 4.5625rem;
  aspect-ratio: 3/2;
  border: .0625rem solid #3c9c8f;
}

.nav_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  margin-top: 2.5rem;
}

.nav_item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 5.5rem;
  font-size: 1rem;
}

.nav_item img {
  width: .875rem;
  height: .875rem;
  margin-left: .3125rem;
}

.nav_item_out {
  cursor: pointer;
  margin-left: .625rem;
  margin-right: .625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.line {
  width: 3.75rem;
  height: .125rem;
  background: #3c9c8f;
  border-radius: .625rem;
  margin-top: .625rem;
}

.line_white {
  width: 3.75rem;
  height: .125rem;
  background: #ffffff;
  border-radius: .625rem;
  margin-top: .625rem;
}

.color_orage {
  color: #3c9c8f;
}

.color_dark_green {
  color: #666666;
}

.cp {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.doc-list{
  width: 100%;
  display: flex;
  flex-direction: column;
  .item-wrap{
    margin-bottom: 1rem;
    display: flex;
  flex-direction: column;
  border-bottom: .0625rem dotted #333;
  .item-title{
    width: 100%;
    text-align: left;
    font-size: 1rem;
    font-weight: bold;
  }
  .doc-item{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: .0625rem dotted #eaeaea;
    padding: .625rem 0;
    .doc{
      font-size: 1rem;
      color: #333333;
    }
    .more{
      font-size: 1rem;
      color: #333;
      text-decoration: none;
    }
    .video-item{
      max-width: 31.25rem;
      width: 100%;
      height: auto;
    }
  }
}
}
.cp_left {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.cp_img {
  position: relative;
  width: 18.75rem;
  height: 12.5rem;
  margin-top: 1.25rem;
}
.cp_img img {
  position: absolute;
  width: 18.75rem;
  height: 12.5rem;
  object-fit: cover;
}
.cp_img span {
  position: absolute;
  bottom: 0;
  left: 0;
  color: white;
  height: 3.125rem;
  line-height: 3.125rem;
  padding-left: 1.25rem;
  box-sizing: border-box;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.6),
    rgba(0, 0, 0, 0.6)
  );
}

.cp_btn {
  cursor: pointer;
  background: #3c9c8f;
  font-size: 1rem;
  color: white;
  font-weight: 100;
  width: 8.5rem;
  text-align: center;
  height: 2.75rem;
  line-height: 2.75rem;
  margin-top: 1.25rem;
  margin-bottom: 3.125rem;
}
.cp_btn2 {
  cursor: pointer;
  background: #3c9c8f;
  font-size: 1rem;
  color: white;
  font-weight: 100;
  width: 8.5rem;
  text-align: center;
  height: 2.75rem;
  line-height: 2.75rem;
  margin-top: 2.5rem;
  margin-bottom: 3.125rem;
}
.user_item3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.25rem;
}
.user_item3 span:nth-child(odd) {
  width: 5rem;
  font-size: .875rem;
  color: #999999;
  text-align: right;
}
.cp_int{
     box-shadow: 0rem 0rem 1.25rem #eeeeee;
    margin-top: 1.25rem;
    position: relative;
    flex: 1;
    height: 16.5rem; 
    padding: 1.25rem;
    box-sizing: border-box;
}
.input_size{
  flex: 1;
    background: #f7f7f7 !important;
} 
.el-input__inner {
    background: #ffffff !important;
}

.carousel-track {
  height: 100%;
  width: 100%; /* 双倍宽度容纳重复图片 */
  display: flex; 
  flex-wrap: wrap;
  margin-top: 1.25rem;
  margin-bottom: 2.5rem;
  gap: .9375rem;
}
.carousel-item3 {
  cursor: pointer;
  width: calc(25% - .75rem);
  // min-width: 17.5rem;
  height: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #ffffff;
  transition: all 0.3s ease;
  &:hover{
    box-shadow: 0rem 0rem 1.25rem #eeeeee; 
  }
}
.carousel-item2_title{
  box-sizing: border-box;
  display: block;
  width: 100%;
  font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: .875rem;
color: #3E3E3E;
  padding: 0 .625rem;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.carousel-item2_img2 {
  width: 100%;
  height: auto;
  aspect-ratio: 3/2;
  object-fit: cover; 
}
:deep(.el-input-number){
  width: 6.875rem !important;
}
</style><style>
.el-input-number {
  position: relative;
  display: inline-block;
  width: 5.625rem !important;
  line-height: 1.75rem !important;
}

.el-input-number__decrease {
  left: .0625rem;
  border-radius: .25rem 0 0 .25rem;
  border-right: .0625rem solid #dcdfe6;
}

.el-input-number__decrease,
.el-input-number__increase {
  position: absolute;
  z-index: 1;
  top: .0625rem;
  width: 1.875rem !important;
  height: auto;
  text-align: center;
  background: #ffffff !important;
  color: #606266;
  cursor: pointer;
  font-size: .8125rem;
}

.el-input-number .el-input__inner {
  -webkit-appearance: none;
  padding-left: .0625rem !important;
  padding-right: .0625rem !important;
  text-align: center;
}

.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: .0625rem !important;
  border: .0625rem solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 1.875rem !important;
  line-height: 1.875rem !important;
  outline: 0;
  padding: 0 .3125rem;
  background: #ffffff !important;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.cc_content {
  display: flex;
  flex-direction: column;
  margin-top: 1.25rem;
  img{
    max-width: 100%;
  }
}

.cc_content span:nth-child(odd) {
  color: #333333;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4375rem;
}

.cc_content span:nth-child(even) {
  color: #333333;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4375rem;
  margin-top: .3125rem;
}
</style>